var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayPerClickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2675 21.15C32.7434 19.6821 33 18.1201 33 16.5C33 7.93959 25.8366 1 17 1C8.16344 1 1 7.93959 1 16.5C1 25.0604 8.16344 32 17 32C20.5736 32 23.8735 30.8651 26.5367 28.9469",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4306 12.3403C21.4306 9.73611 19.3195 7.625 16.7153 7.625C14.1111 7.625 12 9.73611 12 12.3403C12 14.9445 13.8337 16.5317 16.7153 17.0556",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.7739C12 24.3781 14.1111 26.4892 16.7153 26.4892C19.3195 26.4892 21.4306 24.3781 21.4306 21.7739C21.4306 19.1697 19.8588 17.5825 16.7153 17.0586",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7578 6L16.7578 28",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.076 25.1613L33.7778 25.5627L34.1792 25.8609L37.3718 28.2328C37.5934 28.3975 37.6396 28.7107 37.4749 28.9324L36.3124 30.497L35.0577 32.1859C34.8884 32.4137 34.5637 32.4551 34.3427 32.2771L31.2733 29.8049L30.8684 29.4787L30.5583 29.8961L29.8324 30.8731C29.6029 31.1821 29.1249 31.1267 28.9721 30.7734L25.6642 23.1253C25.5114 22.772 25.7984 22.3858 26.1807 22.4301L34.4582 23.3894C34.8405 23.4337 35.0315 23.8753 34.8019 24.1843L34.076 25.1613Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPerClickIcon);
export default __webpack_public_path__ + "static/media/payPerClickIcon.ffd9c3e94e16593ee40aea8c04170486.svg";
export { ForwardRef as ReactComponent };